import { render } from "./AddComputeOffering.vue?vue&type=template&id=541b0eca&scoped=true"
import script from "./AddComputeOffering.vue?vue&type=script&lang=js"
export * from "./AddComputeOffering.vue?vue&type=script&lang=js"

import "./AddComputeOffering.vue?vue&type=style&index=0&id=541b0eca&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.20.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-541b0eca"]])

export default __exports__